import { useQuery } from '@tanstack/react-query';

import {
  discoverySearchStatusQueryOptions,
  type SearchHistoryResponse,
} from '@/entities/discovery';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';

const DEFAULT_REFETCH_INTERVAL = 2_000;

type Options = {
  enabled?: boolean;
  refetchInterval?: number;
};

export function isDiscoverySearchTerminal(
  status: Pick<SearchHistoryResponse, 'complete' | 'progress_percentage'> | null | undefined,
) {
  return status?.complete === true || (status?.progress_percentage ?? 0) >= 100;
}

export function useDiscoverySearchStatus(
  discoverySessionId: string | null | undefined,
  searchId: string | null | undefined,
  options?: Options,
) {
  const { workspaceId } = useWorkspaceId();
  const sessionId = discoverySessionId ?? '';
  const resolvedSearchId = searchId ?? '';

  return useQuery({
    ...discoverySearchStatusQueryOptions(workspaceId, sessionId, resolvedSearchId),
    enabled: sessionId.length > 0 && resolvedSearchId.length > 0 && (options?.enabled ?? true),
    refetchInterval: (query) =>
      isDiscoverySearchTerminal(query.state.data)
        ? false
        : (options?.refetchInterval ?? DEFAULT_REFETCH_INTERVAL),
  });
}
